import {Inject, Injectable} from '@angular/core';
import {MesApiService, AppConfig, ApiResponse, UserTokenModel} from 'common-shared';
import {MesHttpStatusHandlerService} from 'common-shared';
import {Router} from '@angular/router';
import {getAuthTokenKey} from './auth.guard';
import {delay, map} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {plainToInstance} from "class-transformer";

@Injectable({
  providedIn: 'root'
})
export class AuthService extends MesApiService {
  constructor(errorHandlerService: MesHttpStatusHandlerService, public router: Router, @Inject('config') private appConfig: AppConfig) {
    super('auth');
    errorHandlerService.http418.subscribe((exist) => {
      if (exist) {
        this.ensureCurrentUserRemoved();
      }
    });
  }

  login(email: string, password: string, returnUrl: string = null) {
    return this.addGet<any, UserTokenModel>({
      email: email,
      password: password
    }, {
      action: 'Login'
    }).pipe(map((data: ApiResponse<UserTokenModel>) => {
      setTimeout(() => {
        this.storeAuth(data.data);
        this.ensureNavigationToReturnUrl(returnUrl);
      }, 1000);
    }));
  }

  loginById(userId: string, password: string): Subscription {
    return this.addGet<any, UserTokenModel>({
      id: userId,
      password: password
    }, {
      action: 'LoginById'
    }).pipe(delay(10000))
      .subscribe((data: ApiResponse<UserTokenModel>) => {
        this.storeAuth(data.data);
        this.ensureNavigationToReturnUrl();
        return data;
      });
  }

  logout() {
    this.ensureCurrentUserRemoved();
  }

  ensureNavigationToReturnUrl(returnUrl: string = null) {
    if (returnUrl) {
      this.router.navigateByUrl(returnUrl).catch(reason => console.error(reason));
    } else {
      this.router.navigate(['/'])
        .catch(reason => console.error(reason));
    }
  }

  protected ensureCurrentUserRemoved() {
    localStorage.removeItem(getAuthTokenKey(this.appConfig.name));
    window.location.reload();
  }

  protected storeAuth(data: UserTokenModel) {
    localStorage.setItem(getAuthTokenKey(this.appConfig.name), JSON.stringify(data));
  }

  getAuth() {
    return plainToInstance(UserTokenModel, JSON.parse(this.appConfig.Storage.getItem(getAuthTokenKey(this.appConfig.name))));
  }
}
